import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ModelData } from "features/model/types/test/getTestIdShema";

interface TestState {
    model: any;
    isLoading: boolean;
    success:boolean
}

const getTestsSlice = createSlice({
    name: "getTests",
    initialState: {
        model: {},
        isLoading: true,
    } as TestState,
    reducers: {
        getModalTests: (state, action: PayloadAction<ModelData>) => {
            state.model = action.payload;
            state.isLoading = false;
        },
        setLoading: (state, action: PayloadAction<{ isLoading: boolean }>) => {
            state.isLoading = action.payload.isLoading;
        },
        clearTestState: (state) => {
            state.model = {};
            state.isLoading = true;
        },
    },
});

export const { getModalTests, setLoading,clearTestState } = getTestsSlice.actions;
export const getTestsReducer = getTestsSlice.reducer;